import { render, staticRenderFns } from "./jiejingList.vue?vue&type=template&id=23b9370a&scoped=true&"
import script from "./jiejingList.vue?vue&type=script&lang=js&"
export * from "./jiejingList.vue?vue&type=script&lang=js&"
import style0 from "./jiejingList.vue?vue&type=style&index=0&id=23b9370a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b9370a",
  null
  
)

export default component.exports